"use strict";

var Share = require("./share.min.js");

new Share(".share", {
  ui: {
    flyout: "bottom left"
  },
  networks: {
    email: {
      description: window.location.href
    }
  }
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkM6L1VzZXJzL2V3ZWJlY2svRG9jdW1lbnRzL0dpdEh1Yi8yMDE3LW1hcmluZXJzLWxpbmV1cC9zcmMvanMvbGliL3NvY2lhbC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLElBQUksS0FBSyxHQUFHLE9BQU8sQ0FBQyxnQkFBZ0IsQ0FBQyxDQUFDOztBQUV0QyxJQUFJLEtBQUssQ0FBQyxRQUFRLEVBQUU7QUFDbEIsSUFBRSxFQUFFO0FBQ0YsVUFBTSxFQUFFLGFBQWE7R0FDdEI7QUFDRCxVQUFRLEVBQUU7QUFDUixTQUFLLEVBQUU7QUFDTCxpQkFBVyxFQUFFLE1BQU0sQ0FBQyxRQUFRLENBQUMsSUFBSTtLQUNsQztHQUNGO0NBQ0YsQ0FBQyxDQUFDIiwiZmlsZSI6IkM6L1VzZXJzL2V3ZWJlY2svRG9jdW1lbnRzL0dpdEh1Yi8yMDE3LW1hcmluZXJzLWxpbmV1cC9zcmMvanMvbGliL3NvY2lhbC5qcyIsInNvdXJjZXNDb250ZW50IjpbInZhciBTaGFyZSA9IHJlcXVpcmUoXCIuL3NoYXJlLm1pbi5qc1wiKTtcclxuXHJcbm5ldyBTaGFyZShcIi5zaGFyZVwiLCB7XHJcbiAgdWk6IHtcclxuICAgIGZseW91dDogXCJib3R0b20gbGVmdFwiXHJcbiAgfSxcclxuICBuZXR3b3Jrczoge1xyXG4gICAgZW1haWw6IHtcclxuICAgICAgZGVzY3JpcHRpb246IHdpbmRvdy5sb2NhdGlvbi5ocmVmXHJcbiAgICB9XHJcbiAgfVxyXG59KTtcclxuIl19